<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h1>{{$t('finalCustomerDatas.title')}}</h1>
      </div>
    </div>
    <div class="row ">
      <div class="col">
        <div class="row">
          <div class="col-md-12">
            <form id="customerDatas" accept-charset="utf-8" class="needs-validation" novalidate>
              <div class="form-row">
                <div class="form-group">
                  <h2>{{$t('finalCustomerDatas.subtitlePersonal')}}</h2>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.lastname')}}</label>
                  <input type="text" v-model="lastname" :class="'form-control ' + ((lastname !== '') ? 'filledForm' : '')" required>
                  <div class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.lastname')}}
                  </div>
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.firstname')}}</label>
                  <input type="text" v-model="firstname" :class="'form-control ' + ((firstname !== '') ? 'filledForm' : '')" required>
                  <div class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.firstname')}}
                  </div>
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.birthDate')}}</label>
                  <div class="birthdate-datePicker">
                    <datepicker ref="datePickerBirthDay" v-model="birthDate" :language="frTranslationDatepicker" format="dd/MM/yyyy" :initial-view="'year'" :open-date="new Date(new Date().getFullYear() - 35, 0)"
                                :monday-first="true" input-class="form-control datepicker birthdate" name="birthDate" :typeable="false" :required="true" ></datepicker>
                  </div>
                  <div ref="noBirthdate" class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.birthDate')}}
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6 noMargin">
                  <label>{{$t('finalCustomerDatas.adress')}}</label>
                  <input type="text" v-model="adress" :class="'form-control ' + ((adress !== '') ? 'filledForm' : '')">
                  <div class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.adress')}}
                  </div>
                </div>
                <div class="form-group col-md-2 noMargin">
                  <label>{{$t('finalCustomerDatas.postal')}}</label>
                  <input type="text" v-model="postal" :class="'form-control ' + ((postal !== '') ? 'filledForm' : '')">
                  <div class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.postal')}}
                  </div>
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.city')}}</label>
                  <input type="text" v-model="city" :class="'form-control ' + ((city !== '') ? 'filledForm' : '')">
                  <div class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.city')}}
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.phone')}}</label>
                  <input type="tel" pattern="^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$" v-model="phone" :class="'form-control ' + ((phone !== '') ? 'filledForm' : '')">
                  <div class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.phone')}}
                  </div>
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.mail')}}</label>
                  <input type="email" v-model="email" pattern="^\S+@\S+\.\S+$" :class="'form-control ' + ((email !== '') ? 'filledForm' : '')" required>
                  <div class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.mail')}}
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <h2>{{$t('finalCustomerDatas.subtitleBank')}}</h2>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.lastname')}}</label>
                  <input :disabled="isNoDataBank" v-model="bankLastname" type="text" :class="'form-control ' + ((bankLastname !== '') ? 'filledForm' : '')" :required="'isNoDataBank'">
                  <div v-show="isNoDataBank === false" class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.lastname')}}
                  </div>
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.firstname')}}</label>
                  <input :disabled="isNoDataBank" v-model="bankFirstname" type="text" :class="'form-control ' + ((bankFirstname !== '') ? 'filledForm' : '')" :required="'isNoDataBank'">
                  <div v-show="isNoDataBank === false" class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.firstname')}}
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.iban')}}</label>
                  <input :disabled="isNoDataBank" v-model="bankIban" pattern="^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$" type="text" :class="'form-control ' + ((bankIban !== '') ? 'filledForm' : '')" :required="'isNoDataBank'">
                  <div v-show="isNoDataBank === false" class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.iban')}}
                  </div>
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.bic')}}</label>
                  <input :disabled="isNoDataBank" v-model="bankBic" pattern="^([a-zA-Z]{4})([a-zA-Z]{2})(([2-9a-zA-Z]{1})([0-9a-np-zA-NP-Z]{1}))((([0-9a-wy-zA-WY-Z]{1})([0-9a-zA-Z]{2}))|([xX]{3})|)$" type="text" :class="'form-control ' + ((bankIban !== '') ? 'filledForm' : '')" :required="'isNoDataBank'">
                  <div v-show="isNoDataBank === false" class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.bic')}}
                  </div>
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.bankName')}}</label>
                  <input :disabled="isNoDataBank" v-model="bankName" type="text" :class="'form-control ' + ((bankName !== '') ? 'filledForm' : '')" :required="'isNoDataBank'">
                  <div v-show="isNoDataBank === false" class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.bankName')}}
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12" style="margin-top: -20px;">
                  <label><input type="checkbox" value="true" v-model="isNoDataBank"/> {{$t('finalCustomerDatas.isDataBank')}}</label>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <h2>{{$t('finalCustomerDatas.subtitleSubscription')}}</h2>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.startDate')}}</label>
                  <div class="subscriptionStartDate">
                    <datepicker v-model="subscriptionStartDate" :language="frTranslationDatepicker" format="dd/MM/yyyy" :monday-first="true"
                                input-class="form-control datepicker" name="subscriptionStartDate" :typeable="false" :required="true"></datepicker>
                  </div>
                  <div class="invalid-feedback">
                    {{$t('finalCustomerDatas.formValidation.startDate')}}
                  </div>
                </div>
                <div class="form-group col-md-4 noMargin">
                  <label>{{$t('finalCustomerDatas.club')}}</label>
                  <select v-model="subscriptionClub" class="form-control filledForm" required>
                    <option v-for="(club, index) in clubs" :value="club.zoneId" :key="index">{{club.clubName}}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col overFooter">
        <button type="submit" :class="'btn btn-primary alignRight ' + ((firstname && lastname && birthDate && email && validateEmail(email) && subscriptionStartDate && ((bankFirstname && bankLastname && bankIban && validateIban(bankIban) && bankName) || isNoDataBank === true)) ? 'bg-color' : '')" @click="saveData($event)">{{$t('general.send')}}</button>
      </div>
    </div>
  </div>

</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {en, fr} from 'vuejs-datepicker/dist/locale';
export default {
  name: 'final-customer-datas',
  components: {
    'datepicker': Datepicker
  },
  data () {
    return {
      clubs: '', // TODO: Call Node API liste des clubs
      firstname: this.$store.state.form.resultJson.userInfos.firstname,
      lastname: this.$store.state.form.resultJson.userInfos.lastname,
      birthDate: '',
      adress: '',
      postal: '',
      city: '',
      phone: this.$store.state.form.resultJson.userInfos.phone,
      email: this.$store.state.form.resultJson.userInfos.email,
      bankFirstname: this.$store.state.form.resultJson.userInfos.firstname,
      bankLastname: this.$store.state.form.resultJson.userInfos.lastname,
      bankIban: '',
      bankBic: '',
      bankName: '',
      subscriptionStartDate: (new Date()).toISOString().split('T')[0],
      subscriptionClub: '',
      subscriptionMemberNum: '',
      subscriptionMandataryCode: '',
      isNoDataBank: false,
      enTranslationDatepicker: en,
      frTranslationDatepicker: fr
    };
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'FinalCustomerDatas', isAuthorized: (this.firstname !== '' && this.lastname !== '' && this.birthDate !== '' && this.email !== '' && this.validateEmail(this.email)) && this.subscriptionStartDate !== '' && ((this.bankFirstname !== '' && this.bankLastname !== '' && this.bankIban !== '' && this.validateIban(this.bankIban) && this.bankBic !== '' && this.validateIban(this.bankBic) && this.bankName !== '') || this.isNoDataBank === true), data: this.dataTosave});
  },
  mounted: function () {
    this.getAllClubs();
  },
  methods: {
    saveData: function ($event) {
      let form = document.getElementById('customerDatas');
      // En attendant le merge de cette pull request https://github.com/charliekassel/vuejs-datepicker/pull/536 --> on vérifique la date de naissance a bien été rentrée
      if (form.checkValidity() === false || !this.birthDate) {
        this.birthdateValidation();
        $event.preventDefault();
        $event.stopPropagation();
      } else {
        this.birthdateValidation();
        this.$store.dispatch('form/FORM_NEXTLAYOUT', this.dataTosave);
      }
      form.classList.add('was-validated');
    },
    findWithAttr: function (array, attr, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    validateEmail: function (email) {
      /* eslint-disable no-useless-escape */
      var re = /^\S+@\S+\.\S+$/;
      return re.test(String(email).toLowerCase());
    },
    validatePhone: function (tel) {
      /* eslint-disable no-useless-escape */
      var re = /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;
      return re.test(String(tel));
    },
    validateIban: function (iban) {
      var re = /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$/;
      if (this.isNoDataBank === false) {
        return re.test(String(iban));
      }
      return false;
    },
    validateBic: function (bic) {
      var re = /^([a-zA-Z]{4})([a-zA-Z]{2})(([2-9a-zA-Z]{1})([0-9a-np-zA-NP-Z]{1}))((([0-9a-wy-zA-WY-Z]{1})([0-9a-zA-Z]{2}))|([xX]{3})|)$/;
      if (this.isNoDataBank === false) {
        return re.test(String(bic));
      }
      return false;
    },
    getAllClubs: async function () {
      let infosCLub = await this.$http.get('zone'
      ) // eslint-disable-next-line
        .catch((err) => {
          this.$sentry.captureExceptionWithTags(err, {}, this.$options.name, 'getAllClubs');
          this.$notify({
            type: 'error',
            title: this.$t('general.errorApi.generalTitle'),
            text: this.$t('general.errorApi.listClubs.errormsg')
          });
        });

      if (infosCLub.data.errno !== undefined) {
        this.$notify({type: 'error', title: this.$t('general.errorApi.generalTitle'), text: infosCLub.data.errormsg});
      }
      this.clubs = infosCLub.data.response;
      if (this.clubs.length !== 0) {
        this.subscriptionClub = this.clubs[0].zoneId;
      }
    },
    birthdateValidation: function () {
      if (!this.birthDate) {
        document.getElementsByClassName('birthdate')[0].style.border = '1px solid #dc3545';
        this.$refs.noBirthdate.style.display = 'block';
      } else {
        this.$refs.noBirthdate.style.display = 'none';
        document.getElementsByClassName('birthdate')[0].style.border = '1px solid #ced4da';
      }
    }
  },
  computed: {
    dataTosave: function () {
      return {
        finalUserInfos: {
          personal: {
            firstname: this.firstname,
            lastname: this.lastname,
            birthDate: this.$formatDateToISO(this.birthDate),
            adress: this.adress !== '' ? this.adress : null,
            postal: this.postal !== '' ? this.postal : null,
            city: this.city !== '' ? this.city : null,
            phone: this.phone !== '' ? this.phone : null,
            email: this.email
          },
          bank: {
            bankFirstname: (!this.isNoDataBank) ? this.bankFirstname : null,
            bankLastname: (!this.isNoDataBank) ? this.bankLastname : null,
            bankIban: (!this.isNoDataBank) ? this.bankIban.toUpperCase() : null,
            bankBic: (!this.isNoDataBank) ? this.bankBic.toUpperCase() : null,
            bankName: (!this.isNoDataBank) ? this.bankName : null
          },
          subscription: {
            subscriptionStartDate: this.$formatDateToISO(this.subscriptionStartDate),
            subscriptionClub: this.subscriptionClub
          }
        }
      };
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/layouts/FinalCustomerDatas.vue